var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeadzones = function SvgDeadzones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm-.515 9.838H2.724a8.284 8.284 0 0 0 7.761 7.93v-7.93zm8.791 0h-7.575l.001 7.916a8.284 8.284 0 0 0 7.574-7.915zm-8.79-8.606a8.285 8.285 0 0 0-7.723 7.39l7.722-.001zm1.216.014-.001 7.375h7.536a8.286 8.286 0 0 0-7.535-7.375z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgDeadzones;